module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'form',
    ],

    model: {
        globalStaticFields: {
            status: 'inactive'
        }
    },

    methods: {


        onAttachDone: function(){
            var scopeRoles;
            // select right scopeRoles if necessary
            if(this.resourceData.data && this.resourceData.data.children && this.resourceData.data.children.um_users_scopeRoles && (scopeRoles = this.resourceData.data.children.um_users_scopeRoles.data)){

                // reset dirty fields to prevent unnecessary deletions if necessary
                if(((((this.model.dirtyFields || {}).data || {}).children || {}).um_users_scopeRoles || {}).data){
                    this.model.dirtyFields.data.children.um_users_scopeRoles.data = [];
                }

                this.find('templates_core_form_fields_selectScopeRoles', function(component){
                    component.selectScopeRoles(scopeRoles);
                });
            }
        }
    }
}